<!-- eslint-disable max-lines -->
<template>
    <el-dialog
        class="change_information_dialog"
        :visible.sync="openChangeDialog"
        :close-on-click-modal="closeOnClickModal"
        top="4%"
        width="660px"
        :before-close="closeDialog"
        :title="title"
        >
        <el-tabs v-model="activeName_" @tab-click="handleClick">
            <el-tab-pane v-if="changeType === '1' || changeType === '0'" label="基础信息" name="1">
                <el-form v-if="supplierTab.propertyNature + '' !== PERSON" inline ref="basicForm" :rules="basicRules" :model="basicForm" label-width="140px" size="mini">
                    <el-form-item label="供应商编码" prop="supplierCode" :disabled="true">
                        <el-input v-model="basicForm.supplierCode" placeholder="供应商编码" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="公司名称" prop="supplierNameCn" :disabled="disabled">
                        <el-tooltip v-if="disabled" :content="basicForm.supplierNameCn" placement="top">
                            <el-input v-model="basicForm.supplierNameCn" placeholder="请输入公司名称" :disabled="disabled"></el-input>
                        </el-tooltip>
                        <el-input v-else v-model="basicForm.supplierNameCn" placeholder="请输入公司名称" :disabled="disabled"></el-input>
                    </el-form-item>
                    <el-form-item v-if="supplierTab.supplierType !== OCEANFREIGHT_SUPPLIER" label="统一社会信用代码" prop="societyCreditCode" :disabled="disabled">
                        <el-input v-model.trim="basicForm.societyCreditCode" placeholder="请输入统一社会信用代码" @change="changeCode" :disabled="disabled"></el-input>
                    </el-form-item>
                    <el-form-item v-if="supplierTab.supplierType !== OCEANFREIGHT_SUPPLIER" label="法人代表" prop="corporateName">
                        <el-input v-model="basicForm.corporateName" placeholder="请输入法人代表" :disabled="disabled"></el-input>
                    </el-form-item>
                    <el-form-item v-if="supplierTab.supplierType !== OCEANFREIGHT_SUPPLIER" label="法人身份证号" prop="idCard">
                        <el-input v-model="basicForm.idCard" placeholder="请输入身份证号" :disabled="disabled"></el-input>
                        <div v-if="supplierTab.propertyNature + '' === '1'|| supplierTab.propertyNature + '' === '3'" class="isChina__radio">
                            <el-radio-group v-model="isChina">
                                <el-radio label="0">中国大陆</el-radio>
                                <el-radio label="1">其他</el-radio>
                            </el-radio-group>
                        </div>
                    </el-form-item>
                    <!-- <el-form-item label="组织机构代码" prop="orgCode">
                        <el-input v-model="basicForm.orgCode" placeholder="请输入组织机构代码" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="营业执照注册号" prop="businessLicenseNo">
                        <el-input v-model="basicForm.businessLicenseNo" placeholder="请输入营业执照注册号" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="税务登记号" prop="taxRegistNo">
                        <el-input v-model="basicForm.taxRegistNo" placeholder="请输入税务登记号" :disabled="true"></el-input>
                    </el-form-item> -->
                    <div></div>
                    <el-form-item label="营业执照注册起始日期" prop="businessLicenseDateFrom" v-if="supplierTab.propertyNature + '' === COMPANY">
                        <el-date-picker value-format="yyyy-MM-dd" v-model="basicForm.businessLicenseDateFrom" type="date" :disabled="disabled"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="营业执照注册终止日期" prop="businessLicenseDateTo" v-if="supplierTab.propertyNature + '' === COMPANY">
                        <el-date-picker value-format="yyyy-MM-dd" v-model="basicForm.businessLicenseDateTo" type="date" :disabled="disabled" :picker-options="pickerOptions"></el-date-picker>
                    </el-form-item>
                    <el-form-item v-if="!$store.state.supplier" label="供应商来源途径" prop="supplierSourceWay">
                        <div class="two-columns">
                            <m-select :value="basicForm.supplierSourceWay" :optionNum="'SUPPLIER_SOURCE_ROUTE'" @input="(data)=>propsChange(data, 'supplierSourceWay')" :disabled="disabled"></m-select>
                            <!-- 供应商来源途径=其他，需要展示输入框 -->
                            <el-input
                            v-if="basicForm.supplierSourceWay === '11'"
                            type="text"
                            clearable
                            :disabled="disabled"
                            placeholder="请输入具体寻源途径"
                            maxlength="15"
                            v-model="basicForm.specificSourceWay"
                            show-word-limit
                            class="two-columns-input"
                            ></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item label="运输业务类型" prop="transportBusinessTypeList" v-if="overseaFlag">
                        <m-select
                            :value="basicForm.transportBusinessTypeList"
                            :optionNum="'SRM_TRANSPORT_BUSINESS_TYPE'"
                            multiple
                            :disabled="disabled"
                            @input="tbtPropsChange"
                        ></m-select>
                    </el-form-item>
                </el-form>
                <el-form v-if="supplierTab.propertyNature + '' === PERSON" inline ref="basicForm" :rules="basicRules" :model="basicForm" label-width="120px" size="mini">
                    <el-form-item label="供应商编码" prop="supplierCode" :disabled="true">
                        <el-input v-model="basicForm.supplierCode" placeholder="供应商编码" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="供应商名称" prop="supplierNameCn" :disabled="disabled">
                        <el-input v-model="basicForm.supplierNameCn" placeholder="请输入供应商名称" :disabled="disabled" :maxlength="maxLength"></el-input>
                    </el-form-item>
                    <el-form-item label="负责人姓名" prop="corporateName" :disabled="disabled">
                        <el-input v-model="basicForm.corporateName" placeholder="请输入负责人姓名" :maxlength="maxLength" @input="changeCorporateName" :disabled="disabled"></el-input>
                    </el-form-item>
                    <el-form-item label="身份证号" prop="idCard">
                        <el-input v-model="basicForm.idCard" placeholder="请输入身份证号" :disabled="disabled"></el-input>
                    </el-form-item>
                </el-form>
                <el-table border :data="tableData">
                    <el-table-column prop="qualificationName" label="附件名称" width="330"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <upload class="upload"
                            :uploadDisplayType="'text'" :text="'上传'" :flag="scope.$index" :accept="'image/*'" @uploadSuccess="callback" v-if="showUpload"></upload>
                            <el-button type="text" @click="preview(scope.row)">预览</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane v-if="changeType === '2' || showFinanceForm === true || changeType === '0'" label="财务信息" name="2">
                <el-form inline ref="financeForm" :model="financeForm" label-width="120px" size="mini">
                    <el-form-item label="供应商编码" prop="supplierCode" :disabled="true">
                        <el-input v-model="financeForm.supplierCode" placeholder="供应商编码" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="付款方式" prop="paymentType">
                        <m-select :value="financeForm.paymentType" :optionNum="'SYS_PAYMENT_TYPE'" @input="(data)=>propsChange(data, 'paymentType')" :disabled="disabled"></m-select>
                    </el-form-item>
                    <el-form-item label="付款条件" prop="paymentTerms">
                        <m-select v-if="paymentOptArr.length" :value="financeForm.paymentTerms" :option-arr="paymentOptArr" @input="(data)=>propsChange(data, 'paymentTerms')" :disabled="disabled"></m-select>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane v-if="changeType === '3' || showCarriersType === true" label="承运商类别" name="3">
                <el-form inline ref="carriersForm" :model="carriersForm" label-width="120px" size="mini">
                    <el-form-item label="供应商编码" prop="supplierCode" :disabled="true">
                        <el-input v-model="carriersForm.supplierCode" placeholder="供应商编码" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="运输方式" prop="transportType" v-if="carriersForm.transportType">
                        <el-select v-model="carriersForm.transportType " placeholder="请选择" @change="selectTransportType" :disabled="disabled || overseaFlag">
                            <el-option
                                v-for="(item, index) in transportType"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="承运商类别" prop="transType" v-if="showCarriersTab">
                        <el-select @change="changeCarriers" v-model="carriersForm.transType" placeholder="请选择" :disabled="disabled">
                            <el-option
                                v-for="item in carrierOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="是否直控运力" prop="isControlTransport">
                        <m-select :value="carriersForm.isControlTransport" @input="(data)=>carriersFormPropsChange(data, 'isControlTransport')" :optionNum="'SYS_SUPPLIER_YES_NO'"
                            :clearable="false" :disabled="isCtDisabled"></m-select>
                    </el-form-item>
                </el-form>
                <el-table border :data="attachmentList" v-if="attachmentList.length">
                    <el-table-column label="变更要求信息" width="330" :show-overflow-tooltip="true">
                        <template slot-scope="{row}">
                            <span>{{ row.tabConfigCode ? row.tabName : row.qualificationName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="是否已填写" width="110">
                        <template slot-scope="{row}">
                            <div>{{ isDone(row) ? '是' : '否' }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.tabConfigCode && !disabled" type="text" @click="toAdd(scope.row)">{{scope.row.goFill === '1' ? '补充货站信息' : '填写'}}</el-button>
                            <el-button v-if="scope.row.tabConfigCode && disabled" type="text" @click="viewTabInfo(scope.row)">查看</el-button>
                            <template v-if="!scope.row.tabConfigCode">
                                <el-button v-if="qualificationLineTypes.includes(scope.row.qualificationName) && !disabled" type="text" @click="handleWrite(scope.row,scope.row.qualificationName)">线上填写</el-button>
                                <el-button type="text" v-if="!disabled" @click="handleUpload(scope.row)">上传</el-button>
                                <el-button type="text" @click="preview(scope.row)">预览</el-button>
                                <el-button v-if="scope.row.qualificationName === '业务运作规模清单' && !disabled" type="text" @click="downloadTemplate(scope.row)">下载模板</el-button>
                            </template>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane v-if="changeType === '4'" label="账户信息" name="4">
                <el-form inline ref="bankForm" :rules="bankRules" :model="bankForm" label-width="120px" size="mini">
                    <el-form-item label="供应商编码" prop="supplierCode" :disabled="true">
                        <el-input v-model="bankForm.supplierCode" placeholder="供应商编码" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="银行账号" prop="bankAccount">
                        <el-input v-model="bankForm.bankAccount" placeholder="请输入银行账号" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="银行账户名" prop="bankAccountName">
                        <el-input v-model="bankForm.bankAccountName" placeholder="请输入银行账户名" :disabled="disabled"></el-input>
                    </el-form-item>
                    <el-form-item label="开户行名称" prop="bankName">
                        <advance
                            :mValue="bankForm.bankName"
                            class="advance-item"
                            :params="params"
                            @getAdvanceValue='getAdvanceValue'
                            :disabled="true">
                        </advance>
                    </el-form-item>
                    <el-form-item label="开户行编号" prop="bankCode">
                        <el-input v-model="bankForm.bankCode" placeholder="请输入开户行编号" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="联行号" prop="ubankNo">
                        <el-input v-model="bankForm.ubankNo" placeholder="请输入联行号" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="开户行地址" prop="bankAddress">
                        <el-input v-model="bankForm.bankAddress" placeholder="请输入开户行地址"  :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="币种" prop="accountCurrencyName">
                        <m-select :value="bankForm.accountCurrencyName"
                        :optionNum="'SU_CURRENCY'" :filterable="true" @input="(data)=>propsChange(data, 'accountCurrencyName')"
                        class="select-item" :disabled="disabled"></m-select>
                    </el-form-item>
                    <el-form-item label="账户类型" prop="accountType">
                        <m-select :optionNum="'SYS_ACCOUNTS_TYPE'"
                        :value="bankForm.accountType" :filterable="true"
                        @input="(data)=>propsChange(data, 'accountType')"
                        class="select-item" :disabled="true"></m-select>
                    </el-form-item>
                    <el-form-item label="SWIFT CODE" prop="swiftCode">
                        <el-input v-model.trim="bankForm.swiftCode" placeholder="请输入银行统一编号" :disabled="disabled"></el-input>
                    </el-form-item>
                    <el-form-item label="开户证明" prop="fileName" class="fileData">
                        <el-input v-model="bankForm.fileName" placeholder="请上传开户证明" :disabled="disabled"></el-input>
                        <upload class="bankUpload"
                        :uploadDisplayType="'icon'" :accept="'image/*'" @uploadSuccess="callbackSuccess" v-if="showUpload"></upload>
                        <el-button class="bankUpload" type="text" icon="el-icon-view" @click="previewBank"></el-button>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane v-if="changeType === '5' || showOtherForm" label="其他信息" name="5">
                <el-form inline ref="otherForm" :rules="otherRules" :model="otherForm" label-width="120px" size="mini">
                    <el-form-item label="供应商名称" prop="supplierNameCn">
                        <el-tooltip :content="otherForm.supplierNameCn" placement="top">
                            <el-input v-model.trim="otherForm.supplierNameCn" placeholder="请输入供应商名称" :disabled="true"></el-input>
                        </el-tooltip>
                    </el-form-item>
                    <el-form-item label="分公司" prop="companyCode">
                        <advance
                            :disabled="disabled"
                            :mValue="otherForm.companyName"
                            class="advance-item"
                            :params="companyParams"
                            @getAdvanceValue='getOtherAdvanceValue'>
                        </advance>
                    </el-form-item>
                    <el-form-item label="服务平台" prop="siteCode">
                        <advance
                            :disabled="disabled"
                            :mValue="otherForm.siteName"
                            class="advance-item"
                            :params="siteParams"
                            @getAdvanceValue='getOtherAdvanceValue'>
                        </advance>
                    </el-form-item>
                    <el-form-item label="合作方式(其他)" prop="cooperationWays" v-if="isOtherSupplier">
                        <m-select :value="otherForm.cooperationWays" @input="(data)=>otherFormPropsChange(data, 'cooperationWays')" :optionNum="'SU_CORPORATE_TYPE_RL'"></m-select>
                    </el-form-item>
                    <el-form-item label="运力机制合作方式" prop="cooperationMode" v-if="supplierTab.supplierType === LOGISTICS_SUPPLIER">
                        <m-select :value="otherForm.cooperationMode" @input="(data)=>otherFormPropsChange(data, 'cooperationMode')" :optionNum="'SRM_COOPERATION_MODE'"></m-select>
                    </el-form-item>
                    <el-form-item label="合作伙伴起始日期" prop="cooperationDate" v-if="supplierTab.supplierType === LOGISTICS_SUPPLIER">
                        <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" v-model="otherForm.cooperationDate" type="date"></el-date-picker>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane v-if="changeType === '6' || showCorporateForm" label="合作方式" name="6">
                <el-form inline ref="corporateForm" :model="corporateForm" :rules="corporateRules" label-width="120px" size="mini">
                    <el-form-item label="供应商编码" prop="supplierCode" :disabled="true">
                        <el-input v-model="corporateForm.supplierCode" placeholder="供应商编码" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="供应商名称" prop="supplierNameCn" :disabled="true">
                        <el-input v-model="corporateForm.supplierNameCn" placeholder="供应商名称" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="合作方式" prop="corporateType">
                        <m-select :clearable="false" :value="corporateForm.corporateType" @input="(data)=>corPropsChange(data, 'corporateType', 'lesseeType', data === LEASING_MANAGEMENT_NUM)"
                            :optionNum="'SU_CORPORATE_TYPE'" :disabled="disabled"></m-select>
                    </el-form-item>
                    <el-form-item v-if="corporateForm.corporateType && corporateForm.corporateType !== LEASING_MANAGEMENT_NUM" label="租赁商类别" prop="lesseeType">
                        <m-select :clearable="false" :value="corporateForm.lesseeType" @input="(data)=>corPropsChange(data, 'lesseeType')" :optionNum="'SU_LEASE_TYPE'" :disabled="disabled"></m-select>
                    </el-form-item>
                </el-form>
                 <el-table border :data="attachmentList" v-if='attachmentList.length'>
                    <el-table-column prop="qualificationName" label="附件名称" width="330"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" v-if="!disabled" @click="handleUpload(scope.row)">上传</el-button>
                            <el-button type="text" @click="preview(scope.row)">预览</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>
        <span v-if="!hideButton" slot="footer" class="dialog-footer">
          <el-button @click="closeDialog">取 消</el-button>
          <el-button type="primary" @click="confirmDialog(ruleForm)" :disabled="disabledSubmit" :loading="loading">提交审批</el-button>
        </span>
        <attachment-dialog  v-if='attachmentShow' :attachmentShow.sync='attachmentShow' :rowData='rowData'></attachment-dialog>


<!-- 资质上传 -->
        <el-dialog width="515px" class="quality-dialog" :append-to-body="true" :visible.sync="qualityDialog" :before-close="handleClose">
            <div slot="title">上传</div>
            <el-form class='form-item' ref="qualityForm" :model="qualityForm" :rules="qualityRules" label-width="140px">
                <template v-if="![...QUALIFY_TEMP_LIST, INVOICE_CTF, ...OVERSEA_NO_DETAIL].includes(qualityForm.qualificationName)">
                    <el-form-item :label="cerNoLabel" prop="certificateNo" class="dialog-item">
                        <el-input v-model="qualityForm.certificateNo" placeholder="请输入" class="input-class"></el-input>
                    </el-form-item>
                    <el-form-item label="开始日期" prop="certificateBeginDate">
                        <el-date-picker v-model="qualityForm.certificateBeginDate" value-format="yyyy-MM-dd" type="date" placeholder="选择开始日期"></el-date-picker>
                    </el-form-item>
                    <el-form-item label="终止日期" prop="certificateEndDate">
                        <el-date-picker v-model="qualityForm.certificateEndDate" value-format="yyyy-MM-dd" type="date" placeholder="选择终止日期"></el-date-picker>
                    </el-form-item>
                </template>
                 <el-form-item label="上传附件" prop="fileName" class="upload-item">
                    <div>
                        <el-input v-model="qualityForm.fileName" placeholder="点击上传附件" class="input-class" readonly></el-input>
                        <upload 
                            uploadDisplayType="icon"
                            :accept="[...QUALIFY_TEMP_LIST,INVOICE_CTF, ...OVERSEA_WITH_DETAIL, ...OVERSEA_NO_DETAIL].includes(qualityForm.qualificationName) ? 'image/*,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.pdf' :'image/*'"
                            :flag="flag"
                            class="upload-item-icon"
                            @uploadSuccess="qualityCb">
                        </upload>
                        <span @click="previewBtn('normal')" class="preview_btn">预览</span>
                        <span v-if="[INVOICE_CTF].includes(qualityForm.qualificationName)" @click="previewBtn('INVOICE_CTF')" class="preview_btn">样式参考</span>
                    </div> 
                    <template v-if="QUALIFY_TEMP_LIST.includes(qualityForm.qualificationName)">
                        <div style="line-height: 20px;font-size: 12px;">上传文件不超过30MB, 文件支持图片,word,.ppt,.pptx,.pdf,.Excel</div>
                        <el-button type="primary" :loading="tempLoading" @click="handleTemp">下载模板</el-button>
                    </template>
                    <template v-if="isOverseaNoDetail">
                        <div style="line-height: 20px;font-size: 12px;">上传文件不超过30MB, 文件支持图片,word,.ppt,.pptx,.pdf,.Excel</div>
                    </template>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="qualitySave">确 定</el-button>
            </div>
        </el-dialog>
<!-- 身份证上传 -->
        <dialog-box :defautQualificationFlag="qualityForm.defautQualificationFlag" :auto-upload="false" class="quality-dialog" v-if="cerDialogVisible" :appendBody="true" :supplierCode="supplierCode" :cerDialogVisible.sync="cerDialogVisible" :showtype="showtype" :form="qualityForm" :flag="flag"
         @search="cerUploadSuccess" @handleClose="handleClose" @cerCallback="cerCallback" @callback="qualityCb" @previewBtn="previewBtn"></dialog-box>


         <TransLegalDialog ref="tldRef" @submit="onlineSubmit($event,DICNAMEONLINEA)"/>
        <TransPersonDialog ref="tpdRef" @submit="onlineSubmit($event,DICNAMEONLINEB)"/>
        <DeliveryLegalDialog ref="dldRef" @submit="onlineSubmit($event,DICNAMEONLINEC)"/>
        <DeliveryPersonDialog ref="dpdRef" @submit="onlineSubmit($event,DICNAMEONLINED)"/>
        <LessThanDialog ref="ltRef" @submit="onlineSubmit($event,DICNAMEONLINEE)"/>
        <WarehouseDialog ref="whRef" @submit="onlineSubmit($event,DICNAMEONLINEF)"/>
        <StevedoreDialog ref="sdRef" @submit="onlineSubmit($event,DICNAMEONLINEG)"/>
        <OperateDialog ref="OperateDialog" :supplierTab="{supplierCode:supplierCode, transType: carriersForm.transType}" @validate="regularRouteValidate"/>
        <addLessthanDialog ref="addLessthanDialog" :supplierCode="supplierCode" @validate="lessthanValidate"/>
    </el-dialog>

    
    
</template>
<script>
import { LOGISTICS_SUPPLIER, OTHER_SUPPLIER, OCEANFREIGHT_SUPPLIER } from '../constant/supplierListConstant.js';
import { BASE_CONFIG_FIELDS, LEASING_MANAGEMENT_NUM, CHANGHE_CAR, CP_CHANGEHE_CAR, FLEET_CHANGHE_CAR, SHUNTING_CAR, COMPANY, PERSON, OS_LGT } from '../constant/constant.js';
import mSelect from '@/components/lots/otpSelect2/index';
import { uploadFiles,downloadRegisterGuide, addQualification } from '../api/qualification.js';
import upload from './upload/Index';
import attachmentDialog from './AttachmentDialog';
import { identityVerify } from '../constant/formRegular.js';
import { getCarriersType, getBusinessType, getQualificationInfoAndTabForChange } from '../api/changeDetails.js';
import advance from '../components/bulletFrame/otpAdvance';
import { dictWithUrl } from '@/components/lots/api';
import dialogBox from '../views/register/workbench/basicInfoTabs/TabQualification/dialogBox.vue';
import {
    getSupplierBasicQualificationForChange,
} from '../api/changeDetails.js'
import TransLegalDialog from '../views/register/manage/keyData/tabs/qualification/TransLegalDialog.vue';
import TransPersonDialog from '../views/register/manage/keyData/tabs/qualification/TransPersonDialog.vue';
import DeliveryLegalDialog from '../views/register/manage/keyData/tabs/qualification/DeliveryLegalDialog.vue';
import DeliveryPersonDialog from '../views/register/manage/keyData/tabs/qualification/DeliveryPersonDialog.vue';
import LessThanDialog from '../views/register/manage/keyData/tabs/qualification/LessThanDialog.vue';
import WarehouseDialog from '../views/register/manage/keyData/tabs/qualification/WarehouseDialog.vue';
import StevedoreDialog from '../views/register/manage/keyData/tabs/qualification/StevedoreDialog.vue';
import OperateDialog from '../views/register/manage/keyData/tabs/regularRoute/OperateDialog.vue';
import addLessthanDialog from './addLessthanDialog.vue';
const FORM_CONFIG = {
    basicForm: { tabName: '1', label: '基础信息', changeTypeKey: 'basicForm' },
    financeForm: { tabName: '2', label: '财务信息', changeTypeKey: 'financeForm' },
    carriersForm: { tabName: '3', label: '承运商类别', changeTypeKey: 'carriersForm' },
    bankForm: { tabName: '4', label: '账户信息', changeTypeKey: 'bankForm' },
    otherForm: { tabName: '5', label: '其他信息', changeTypeKey: 'otherForm' },
    corporateForm: { tabName: '6', label: '合作方式', changeTypeKey: 'corporateForm' }
};
const IS_DEFAULT_QLF = '0'; // 是否为默认资质
const INVOICE_CTF = '开票底联凭证'
const DICNAMEONLINEA = '供应商评分表-运输-车队供应商&物流供应商';
const DICNAMEONLINEB = '供应商评分表-运输-长合车类';
const DICNAMEONLINEC = '供应商评分表-配送-法人供应商';
const DICNAMEONLINED = '供应商评分表-配送-长合车类';
const DICNAMEONLINEE = '供应商评分表-运输-零担专线';
const DICNAMEONLINEF = '供应商评分表-仓储-仓库管理';
const DICNAMEONLINEG = '供应商评分表-装卸';
const QUALIFY_ONLINE_LIST =[DICNAMEONLINEA,DICNAMEONLINEB,DICNAMEONLINEC,DICNAMEONLINED,DICNAMEONLINEE,DICNAMEONLINEF,DICNAMEONLINEG]
// 资质名称对应模板
const QUALIFY_TEMP_LIST = [
    { name: '与安得无亲属关系证明', fileName: 'proofOfNoRelativity.xlsx' },
    { name: '供应商评分表（运输）', fileName: 'transportScore.xlsx' },
    { name: '供应商评分表（配送）', fileName: 'dispatchingScore.xlsx' },
    { name: '供应商评分表（装卸）', fileName: 'loadUnloadScore.xlsx' },
    { name: '供应商评分表（仓管）', fileName: 'warehouseManagementScore.xlsx' },
    { name: DICNAMEONLINEA, fileName: 'supplierScoreLegalPersonTransport.xlsx' },
    { name: DICNAMEONLINEB, fileName: 'supplierScoreNaturalPersonTransport.xlsx' },
    { name: DICNAMEONLINEC, fileName: 'supplierScoreLegalPersonDelivery.xlsx' },
    { name: DICNAMEONLINED, fileName: 'supplierScoreNaturalPersonDelivery.xlsx' },
    { name: DICNAMEONLINEE, fileName: 'transLegalPersonLessThanTrucklodScore.xlsx' },
    { name: DICNAMEONLINEF, fileName: 'warehouseManagementLegalPersonScore.xlsx' },
    { name: DICNAMEONLINEG, fileName: 'loadUnloadLegalPersonScore.xlsx' },
    { name: '供应商评分表', fileName: 'scoreModel.xlsx' },
    { name: '评审表-水运', fileName: 'waterTransport.xlsx' },
    { name: '评审表-铁运', fileName: 'railwayTransport.xlsx' },
]
const OVERSEA_WITH_DETAIL = ['有船承运人资质（有船承运或船舶登记）', '国际货运代理企业备案表或快递业务经营许可证书', '国际货运代理企业备案或道路经营许可证', '报关资质']
const OVERSEA_NUM_LABEL = ['有船承运人资质编码', '证件编号', '证件编号', '报关资质证件编号']
const OVERSEA_NO_DETAIL = ['国际货运代理企业备案表或无船承运人资质', '国际货运代理企业备案表', '国际货运代理企业备案表（与铁路公司合作合同或授权证明）', '国际货运代理企业备案表', '收款账号开户信息', '订舱代理资质材料']

export default {
    name: 'supplier-black-dialog',
    components: { mSelect, attachmentDialog, upload, advance,dialogBox,TransLegalDialog,TransPersonDialog,DeliveryLegalDialog,DeliveryPersonDialog,LessThanDialog,WarehouseDialog,StevedoreDialog,OperateDialog, addLessthanDialog },
    data() {
        return {
            tempLoading: false,
            DICNAMEONLINEA,
            DICNAMEONLINEB,
            DICNAMEONLINEC,
            DICNAMEONLINED,
            DICNAMEONLINEE,
            DICNAMEONLINEF,
            DICNAMEONLINEG,
            INVOICE_CTF,
            QUALIFY_TEMP_LIST: QUALIFY_TEMP_LIST.map(v => v.name),
            qualificationLineTypes: QUALIFY_ONLINE_LIST,
            paymentOptArr: [], //付款条件下拉选项
            showtype: '0', // 弹窗类型控制
            flag: {},
            cerbehiRowData: {},
            cerRowData: {},
            qualityForm: {
                id: '',
                supplierCode: '',
                qualificationName: '',
                certificateBeginDate: '',
                certificateEndDate: '',
                fileName: '',
                fileUrl: '',
                fileId: '',
                qualificationTypeCode: '',
                qualificationType: '',
                defautQualificationFlag: '',
                certificateNo: ''
            },
            qualityDialog: false,
            cerDialogVisible: false,
            attachmentList: [],
            maxLength: 64,
            closeOnClickModal: false,
            attachmentShow: false,
            ruleForm: 'basicForm',
            basicRules: {
                supplierNameCn: [
                    { required: true, message: '请输入名称', trigger: ['blur', 'change'] }
                ],
                societyCreditCode: [
                    { required: false, message: '请输入公司统一社会信用代码', trigger: ['blur', 'change'] },
                    { pattern: /^[0-9a-zA-Z]{18}$/, message: '请输入18位数字或字母', trigger: ['blur', 'change'] }
                ],
                corporateName: [
                    { required: false, message: '请输入法人代表姓名', trigger: ['blur', 'change'] }
                ],
                idCard: [
                    { pattern: identityVerify, message: '请正确输入身份证号码', trigger: ['blur', 'change'] }
                ],
                orgCode: [
                    { required: false, message: '请输入组织机构代码', trigger: ['blur', 'change'] },
                    { pattern: /^[0-9a-zA-Z]{9}$/, message: '请输入9位数字或字母', trigger: ['blur', 'change'] }
                ],
                businessLicenseNo: [
                    { required: false, message: '请输入公司营业执照注册号', trigger: ['blur', 'change'] },
                    { pattern: /^[0-9a-zA-Z]{18}$/, message: '请输入18位数字或字母', trigger: ['blur', 'change'] }
                ],
                taxRegistNo: [
                    { required: false, message: '请输入公司税务登记号', trigger: ['blur', 'change'] },
                    { pattern: /^[0-9a-zA-Z]{18}$/, message: '请输入18位数字或字母', trigger: ['blur', 'change'] }
                ]
            },
            bankRules: {
                bankAccountName: [
                    { required: true, message: '请输入银行账户名', trigger: ['blur', 'change'] }
                ],
                accountCurrencyName: [
                    { required: true, message: '请输入币种', trigger: ['blur', 'change'] }
                ],
                swiftCode: [
                    { max: 14, message: '最多可输入14位', trigger: ['blur', 'change'] }
                ],
            },
            otherRules: {
                companyCode: [
                    { required: true, message: '请选择分公司', trigger: ['blur', 'change'] }
                ],
                siteCode: [
                    { required: true, message: '请选择服务平台', trigger: ['blur', 'change'] }
                ],
                cooperationWays: [{ required: true, message: '请选择合作方式(其他)', trigger: ['blur', 'change'] }]
            },
            corporateRules: {
                corporateType: [
                    { required: true, message: '请选择合作方式', trigger: ['blur', 'change'] }
                ],
                lesseeType: [
                    { required: true, message: '请选择租赁商类别', trigger: ['blur', 'change'] }
                ]
            },
            check: {},
            uploadDisplayType: 'text',
            uploadDisplayType1: 'icon',
            text: '上传',
            carrierOptions: [],
            invoiceTypeOptions: [],
            taxRateOptions: [],
            params: {
                name: '',
                value: 'bankName',
                advanceLabel: '选择开户行名称',
                requestMethod: 'post',
                advanceConfig: [
                    { prop: 'bankname', value: '银行名称' },
                    { prop: 'banknumber', value: '银行号' },
                    { prop: 'ubankno', value: '联行号' },
                    { prop: 'bankaddress', value: '开户行地址' }
                ],
                tableConfig: [
                    { prop: 'banknumber', value: '银行号' },
                    { prop: 'bankname', value: '银行名称' },
                    { prop: 'ubankno', value: '联行号' },
                    { prop: 'bankaddress', value: '开户行地址' }
                ],
                advanceUrl: '/efContactNumbers',
                prefix: '/api-mdm',
                cbParams: ['banknumber#bankCode', 'bankname#bankName', 'ubankno#ubankNo', 'bankaddress#bankAddress']
            },
            activeName_: '1',
            rowData: {},
            dict: {},
            showCarriersTab: this.showCarriers,
            supplierCode: '',
            isChina: '0',
            LOGISTICS_SUPPLIER,
            OCEANFREIGHT_SUPPLIER,
            LEASING_MANAGEMENT_NUM,
            COMPANY,
            PERSON,
            companyParams: JSON.parse(JSON.stringify(BASE_CONFIG_FIELDS.filter(field => field.code === 'companyCode')[0].params)),
            siteParams: JSON.parse(JSON.stringify(BASE_CONFIG_FIELDS.filter(field => field.code === 'siteCode')[0].params)),
            pickerOptions: {
                disabledDate: (time) => {
                    const endtime =  (new Date()).getTime()
                    return time.getTime() < endtime;
                }
            },
            OVERSEA_WITH_DETAIL,
            OVERSEA_NO_DETAIL,
        };
    },
    props: {
        openChangeDialog: { type: Boolean, default() { return false; } },
        title: { type: String, default() { return ''; } },
        basicForm: { type: Object, default() { return {}; } },
        financeForm: { type: Object, default() { return {}; } },
        carriersForm: { type: Object, default() { return {}; } },
        bankForm: { type: Object, default() { return {}; } },
        otherForm: { type: Object, default() { return {}; } },
        showOtherForm: { type: Boolean, default() { return false; } },
        corporateForm: { type: Object, default() { return {}; } },
        showCorporateForm: { type: Boolean, default() { return false; } },
        disabled: { type: Boolean, default() { return false; } },
        showUpload: { type: Boolean, default() { return true; } },
        showFinanceForm: { type: Boolean, default() { return false; } },
        showCarriersType: { type: Boolean, default() { return false; } },
        showCarriers: { type: Boolean, default() { return true; } },
        disabledSubmit: { type: Boolean, default() { return false; } },
        tableData: { type: Array, default() { return []; } },
        activeName: { type: String, default() { return '1'; } },
        transportType: { type: Array, default() { return []; } },
        supplierTab: {
            type: Object,
            default() {
                return { supplierName: '', propertyNature: '', supplierType: '', businessType: '', corporateType: '' };
            }
        },
        changeType: { type: String, default() { return '0'; } },
        loading: { type: Boolean, default() { return false; } },
        hideButton: { type: Boolean, default() { return false; } }
    },
    computed: {
        isOtherSupplier() { // 是其他供应商类型，供应商变更-其他信息-合作方式(其他)字段 才显示出来OTHER_SUPPLIER
            return this.supplierTab.supplierType === OTHER_SUPPLIER;
        },
        isCtDisabled() {
            // 承运商类型是长合车、城配长合车、车队长合车、自调车 时，是否直控运力置灰
            return [CHANGHE_CAR, CP_CHANGEHE_CAR, FLEET_CHANGHE_CAR, SHUNTING_CAR].includes(this.carriersForm.transType)
        },
        qualityRules(){
            // 判断是否为海外业务的资质
            const isOverseaQlfs = this.qualityForm.defautQualificationFlag === IS_DEFAULT_QLF && [...OVERSEA_WITH_DETAIL, ...OVERSEA_NO_DETAIL].includes(this.qualityForm.qualificationName)
            return {
                certificateNo: [{ required: isOverseaQlfs, message: `请输入${this.cerNoLabel}`, trigger: ['change'] }],
                certificateBeginDate: [{ required: isOverseaQlfs, message: '请选择开始日期', trigger: ['change'] }],
                certificateEndDate: [
                    { required: this.qualityForm.defautQualificationFlag === IS_DEFAULT_QLF, message: '请选择终止日期', trigger: ['blur', 'change'] }
                ],
                fileName: [
                    { required: true, message: '请上传附件' }
                ]
            }
        },
        overseaFlag() {
            // 开关已开，涉外业务类型=生产物流海外
            return this.supplierTab.overseaSwitch && this.supplierTab.isOverseas === OS_LGT
        },
        cerNoLabel() {
            let title = '证件号'
            const idx = OVERSEA_WITH_DETAIL.findIndex(item => item === this.qualityForm.qualificationName)
            if (this.qualityForm.defautQualificationFlag === IS_DEFAULT_QLF && idx >= 0) {
                title = OVERSEA_NUM_LABEL[idx]
            }
            return title
        },
        isOverseaNoDetail() {
            return this.qualityForm.defautQualificationFlag === IS_DEFAULT_QLF && OVERSEA_NO_DETAIL.includes(this.qualityForm.qualificationName)
        },
    },
    methods: {
        //下载模板
        downloadTemplate() {
            downloadRegisterGuide({
                fileName: 'qualityModel.docx',
            }).then(res => {
                if (res) {
                    const blob = new Blob([res], {
                        type: 'application/x-excel;charset=UTF-8',
                    })
                    const objectUrl = URL.createObjectURL(blob)
                    var a = document.createElement('a')
                    a.href = objectUrl
                    a.download = '业务运作规模清单.docx'
                    a.click()
                }
            })
        },
        handleTemp() {
            const qlfItem = QUALIFY_TEMP_LIST.find(item => item.name === this.qualityForm.qualificationName)
            if (!qlfItem) {
                return this.$message.warning('查找不到该模板!')
            }
            this.tempLoading = true;
            downloadRegisterGuide({ fileName: qlfItem.fileName }).then(res => {
                if (res) {
                    const blob = new Blob([res], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                    this.saveAs(blob, qlfItem.name + '.xlsx');
                    this.$message.success('模板已下载!');
                }
            }).finally(() => { this.tempLoading = false; })
        },
        saveAs(blob, filename) {
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename);
            } else {
                const link = document.createElement('a');
                const body = document.querySelector('body');
                link.href = window.URL.createObjectURL(blob);
                link.download = filename;
                link.style.display = 'none';
                body.appendChild(link);
                link.click();
                body.removeChild(link);
                window.URL.revokeObjectURL(link.href);
            }
        },
        /**
         * trans 承运商
         * corp 合作方式
         * changeType:string = 'trans' | 'corp'
         */
        getAttachmentForChange(changeType){
            let api = changeType === 'trans' ? getQualificationInfoAndTabForChange : getSupplierBasicQualificationForChange
            api({
                businessType: this.supplierTab.businessType,
                supplierCode: this.supplierCode,
                transType: changeType == 'trans' ? this.carriersForm.transType : '',
                transportType: changeType == 'trans' ? this.carriersForm.transportType : '',
                corporateType: changeType == 'corp' ? this.corporateForm.corporateType : '',
                lesseeType: (changeType == 'corp' && this.corporateForm.corporateType) ? this.corporateForm.lesseeType : '',
                tenantCode: 'annto'
            }).then(res => {
                this.attachmentList = (res.data || []).map(v => {
                    return {
                        ...v,
                        qualificationName: v.qualificationName || ''
                    }
                })
            })
        },
        changeCarriers(v){
            this.getAttachmentForChange('trans')
            // 承运商类型是长合车、城配长合车、车队长合车、自调车，则直控运力为是
            if ([CHANGHE_CAR, CP_CHANGEHE_CAR, FLEET_CHANGHE_CAR, SHUNTING_CAR].includes(v)) {
                this.carriersForm.isControlTransport = '1'
            } else {
                this.carriersForm.isControlTransport = ''
            }
        },
        cerCallback(data) {
            if (data.ocr === 'idCardFont') { // 身份证人像面
                this.qualityForm.certificateNo = data.data.ocrResult.idNumber;
                this.qualityForm.uploadIdentityFront = data.data.ossResult.localFileName;
                this.qualityForm.uploadIdentityFrontUrl = data.data.ossResult.downUrl;
                this.qualityForm.uploadIdentityFrontFileId = data.data.ossResult.id;
                this.cerRowData = {
                    downUrl: data.data.ossResult.downUrl,
                    fileName: data.data.ossResult.localFileName,
                    fileId: data.data.ossResult.id
                };
                this.qualityForm = { ...this.qualityForm };
                if (!this.qualityForm.certificateNo) {
                    this.$message.warning('请正确上传身份证人像面！');
                    return;
                }
            } else {
                this.qualityForm.certificateBeginDate = data.data.ocrResult.idCardStartTime;
                this.qualityForm.certificateEndDate = data.data.ocrResult.idCardEndTime;
                this.qualityForm.uploadIdentityBehind = data.data.ossResult.localFileName;
                this.qualityForm.uploadIdentityBehindUrl = data.data.ossResult.downUrl;
                this.qualityForm.uploadIdentityBehindFileId = data.data.ossResult.id;
                this.cerbehiRowData = {
                    downUrl: data.data.ossResult.downUrl,
                    fileName: data.data.ossResult.localFileName,
                    fileId: data.data.ossResult.id
                };
                this.qualityForm = { ...this.qualityForm };
            }
            // this.attachmentList = [];
            this.rowData.updateTime = data.data.timestamp;
            this.$message.success('附件上传成功');
        },
        qualitySave() {
            this.$refs['qualityForm'].validate((valid) => {
                if (valid) {
                    if(this.qualityForm.qualificationName === '业务运作规模清单'){
                        let api = this.qualityForm.id ? uploadFiles : addQualification
                        api(this.qualityForm).then(res => {
                            if (res && +res.code === 0) {
                                const idx = this.attachmentList.findIndex(v => v.qualificationName === this.qualityForm.qualificationName)
                                this.$set(this.attachmentList, idx, {...this.attachmentList[idx],...this.qualityForm,downUrl: this.qualityForm.fileUrl})
                                this.handleClose();
                            }
                        })
                    }else{
                        const idx = this.attachmentList.findIndex(v => v.qualificationName === this.qualityForm.qualificationName)
                        this.$set(this.attachmentList, idx, {...this.attachmentList[idx],...this.qualityForm,downUrl: this.qualityForm.fileUrl})
                        this.handleClose();
                    }
                    

                //    uploadFiles(this.qualityForm).then(res => {
                //         if (res && +res.code === 0) {
                //             this.$message.success('上传成功');
                //             const idx = this.attachmentList.findIndex(v => v.qualificationName === this.qualityForm.qualificationName)
                //             this.$set(this.attachmentList, idx, {...this.attachmentList[idx],...this.qualityForm,downUrl: this.qualityForm.fileUrl})
                //             this.handleClose();
                //             // this.search();
                //         }
                //     });
                } else {
                    return false;
                }
            });
        },
        cerUploadSuccess(form){
            const idx = this.attachmentList.findIndex(v => v.qualificationName === form.qualificationName)
            if(idx > -1){
                if(form.uploadIdentityFrontUrl){
                    //uploadIdentityFrontUrl有值就是身份证
                    if(form.qualificationName.indexOf('人像') > -1){
                        this.$set(this.attachmentList, idx, {...this.attachmentList[idx],...form,downUrl: form.uploadIdentityFrontUrl})
                        const i = this.attachmentList.findIndex(v => v.qualificationName.indexOf('国徽') > -1)
                        this.$set(this.attachmentList, i, {...this.attachmentList[i],...form,downUrl: form.uploadIdentityBehindUrl,qualificationName: this.attachmentList[i].qualificationName})
                    }
                    if(form.qualificationName.indexOf('国徽') > -1){
                        this.$set(this.attachmentList, idx, {...this.attachmentList[idx],...form,downUrl: form.uploadIdentityBehindUrl})
                        const i = this.attachmentList.findIndex(v => v.qualificationName.indexOf('人像') > -1)
                        this.$set(this.attachmentList, i, {...this.attachmentList[i],...form,downUrl: form.uploadIdentityFrontUrl,qualificationName: this.attachmentList[i].qualificationName})
                    }
                }else{
                this.$set(this.attachmentList, idx, {...this.attachmentList[idx],...form,downUrl: form.fileUrl})
                }
            }
        },
        previewBtn(flag) {
            if (flag === 'normal' && this.qualityForm.fileName) {
                this.attachmentShow = true;
                this.rowData.downUrl = this.qualityForm.fileUrl;
                return;
            }
            if (flag === 'cer' && this.cerRowData.fileName) {
                this.attachmentShow = true;
                this.rowData = this.cerRowData;
                return;
            }
            if (flag === 'cerbehi' && this.cerbehiRowData.fileName) {
                this.attachmentShow = true;
                this.rowData = this.cerbehiRowData;
                return;
            }
             // 开票底联凭证 样式参考
             if (flag === 'INVOICE_CTF') {
                this.attachmentShow = true;
                this.rowData = { downUrl: require('../views/register/manage/keyData/tabs/qualification/imgs/kpdlpzYsck.png') }
                return;
            }
            this.$message.warning('请上传附件');
        },
        qualityCb(data) {
            if (data.data.code === '0') {
                this.rowData = data.data.data;
                // this.attachmentList = [];
                this.rowData.updateTime = data.data.timestamp;
                this.qualityForm.fileName = data.data.data.localFileName;
                this.qualityForm.fileUrl = data.data.data.downUrl;
                this.qualityForm.fileId = data.data.data.id;
                this.qualityForm.id = data.flag.id;
                this.$message.success('附件上传成功');
            } else {
                this.$message.error('上传失败');
            }
        },
        handleClose(type) {
            this.qualityForm = {
                id: '',
                supplierCode: this.supplierCode,
                qualificationName: '',
                certificateBeginDate: '',
                certificateEndDate: '',
                fileName: '',
                fileUrl: '',
                qualificationTypeCode: '',
                qualificationType: '',
                certificateNo: ''
            };
            this.cerRowData = {};
            this.cerbehiRowData = {};
            this.cerDialogVisible = false;
            this.qualityDialog = false;
            if (type === 'cert') { return; }
            this.$refs['qualityForm'].resetFields();
        },
        lessthanValidate(res, lessSystemInfo){
            //零担对接平台
            const idx = this.attachmentList.findIndex(v => v.tabConfigCode === 18)
            this.$set(this.attachmentList[idx], 'params', res)
            this.$set(this.attachmentList[idx], 'lessSystemInfo', lessSystemInfo)
        },
        regularRouteValidate(res,commonRouteInfo){
            //常跑线路
            const idx = this.attachmentList.findIndex(v => v.tabConfigCode === 13)
            this.$set(this.attachmentList[idx], 'params', res)
            this.$set(this.attachmentList[idx], 'commonRouteInfo', commonRouteInfo)
        },
        viewTabInfo(row){
            if(row.tabConfigCode === 13){
                //常跑线路
                this.$refs['OperateDialog'].init(row.params,'detail')
            }else if (row.tabConfigCode === 18){
                //零担对接平台
                this.$refs['addLessthanDialog'].init(row.params, 'detail')
            }
        },
        toAdd(row){
            if(row.tabConfigCode === 13){
                //常跑线路
                if(row.goFill === '1' && !this.isDone(row.hasData)){
                    //goFill 是否需要去补充 :  0否；1是
                    this.$alert('已维护的常跑线路中缺乏货站信息，请补充', '提示', {
                        showClose: true,
                        confirmButtonText: '去补充',
                        callback: action => {
                            if(action === 'confirm'){
                                this.$emit('goFill')
                                this.closeDialog()
                            }
                        }
                    });
                }else{
                    this.$refs['OperateDialog'].init(row.params,'supplement')
                }
            }else if (row.tabConfigCode === 18){
                //零担对接平台
                this.$refs['addLessthanDialog'].init(row.params, 'add')
            }
        },
        handleWrite(row,qualificationName) {
            if(qualificationName === DICNAMEONLINEA){
                this.$refs.tldRef && this.$refs.tldRef.open({...row,qualificationTypeCode:this.supplierCode})
            }
            else if(qualificationName === DICNAMEONLINEB){
                this.$refs.tpdRef && this.$refs.tpdRef.open({...row,qualificationTypeCode:this.supplierCode})
            }
            else if(qualificationName === DICNAMEONLINEC){
                this.$refs.dldRef && this.$refs.dldRef.open({...row,qualificationTypeCode:this.supplierCode})
            }
            else if(qualificationName === DICNAMEONLINED){
                this.$refs.dpdRef && this.$refs.dpdRef.open({...row,qualificationTypeCode:this.supplierCode})
            }
            else if(qualificationName === DICNAMEONLINEE){
                this.$refs.ltRef && this.$refs.ltRef.open({...row,qualificationTypeCode:this.supplierCode})
            }
            else if(qualificationName === DICNAMEONLINEF){
                this.$refs.whRef && this.$refs.whRef.open({...row,qualificationTypeCode:this.supplierCode})
            }
            else if(qualificationName === DICNAMEONLINEG){
                this.$refs.sdRef && this.$refs.sdRef.open({...row,qualificationTypeCode:this.supplierCode})
            }
        },
        onlineSubmit(fileObj,name){
            const idx = this.attachmentList.findIndex(v => v.qualificationName === name)
            this.$set(this.attachmentList[idx], 'downUrl', fileObj.fileUrl)
            this.$set(this.attachmentList[idx], 'fileUrl', fileObj.fileUrl)
            this.$set(this.attachmentList[idx], 'fileName', fileObj.fileName)
            this.$set(this.attachmentList[idx], 'fileId', fileObj.fileId)
        },
        handleUpload(row){
            this.qualityForm.qualificationType = row.qualificationType;
            this.qualityForm.qualificationTypeCode = row.qualificationTypeCode || this.supplierCode;
            this.qualityForm.supplierCode = row.supplierCode;
            this.qualityForm.certificateBeginDate = row.certificateBeginDate;
            this.qualityForm.qualificationName = row.qualificationName;
            this.qualityForm.certificateEndDate = row.certificateEndDate;
            this.$set(this.qualityForm, 'defautQualificationFlag', row.defautQualificationFlag)
            this.flag = {
                id: row.id,
                qualificationType: row.qualificationType,
                qualificationTypeCode: row.qualificationTypeCode,
                qualificationName: row.qualificationName
            };
            if (row.qualificationName.indexOf('身份证') > -1 || row.qualificationName.indexOf('身份证') > -1) {
                this.qualityForm.certificateNo = this.basicForm.idCard;
                this.showtype = '1';
                this.cerDialogVisible = true;
            } else if (row.qualificationName.indexOf('营业执照') > -1 || row.qualificationName === '道路经营许可证' ||
                row.qualificationName === '快递业务经营许可证') {
                this.qualityForm.certificateNo = row.qualificationName.indexOf('营业执照') > -1 ? this.basicForm.businessLicenseNo : row.certificateNo;
                this.showtype = row.qualificationName.indexOf('营业执照') > -1 ? '2' : row.qualificationName.indexOf('道路经营许可证') > -1 ? '3' : '4';
                this.cerDialogVisible = true;
            } else {
                this.qualityForm.certificateNo = row.certificateNo;
                this.qualityDialog = true
            }
        },
        attachmentSuccess(data){
            if (data.data.code === '0') {
                this.$message.success('上传成功');
                this.$set(this.attachmentList[data.flag], 'fileId', data.data.data.id)
                this.$set(this.attachmentList[data.flag], 'downUrl', data.data.data.downUrl)
                this.$set(this.attachmentList[data.flag], 'fileName', data.data.data.localFileName)
            } else {
                this.$message.error('上传失败');
            }
        },
        closeDialog() {
            this.$emit('closeDialog', false);
        },
        handleClick() {
            this.ruleForm = Object.keys(FORM_CONFIG).find(item => FORM_CONFIG[item].tabName === this.activeName_);
        },
        preview(data) {
            if (!data.downUrl && !data.fileUrl) {
                this.$message.warning('请先上传附件');
            } else {
                this.rowData = {...data,downUrl: data.downUrl || data.fileUrl};
                this.attachmentShow = true;
            }
        },
        previewBank() {
            if (!this.bankForm.fileUrl) {
                this.$message.warning('请先上传附件');
            } else {
                this.rowData = {
                    fileName: this.bankForm.fileName,
                    downUrl: this.bankForm.fileUrl
                };
                this.attachmentShow = true;
            }
        },
        callback(data) {
            if (data.data.code === '0') {
                this.$message.success('上传成功');
                this.tableData[data.flag].fileId = data.data.data.id;
                this.tableData[data.flag].downUrl = data.data.data.downUrl;
                this.tableData[data.flag].fileName = data.data.data.localFileName;
            } else {
                this.$message.error('上传失败');
            }
        },
        callbackSuccess(data) {
            if (data.data.code === '0') {
                this.$message.success('上传成功');
                this.$set(this.bankForm, 'fileName', data.data.data.localFileName);
                this.bankForm.fileId = data.data.data.id;
                this.bankForm.downUrl = data.data.data.downUrl;
                this.check.rowData = data.data.data;
            } else {
                this.$message.error('上传失败');
            }
        },
        propsChange(value, prop) {
            const data = {};
            data[prop] = value;
            if(prop === 'supplierSourceWay'){
                Object.assign(this.basicForm, data);
            }else{
                Object.assign(this.financeForm, data);
            }
        },
        corPropsChange(value, prop, childProp, childReset) {
            const data = {};
            data[prop] = value;
            if (childProp && childReset) {
                data[childProp] = null;
            }
            Object.assign(this.corporateForm, data);
            this.getAttachmentForChange('corp')
        },
        carriersFormPropsChange(value, prop) {
            this.carriersForm[prop] = value;
        },
        otherFormPropsChange(value, prop) {
            this.otherForm[prop] = value;
        },
        changeCode() {
            const tmp = this.basicForm.societyCreditCode;
            const startIndex = 8;
            const endIndex = 17;
            this.$set(this.basicForm, 'businessLicenseNo', tmp);
            this.$set(this.basicForm, 'taxRegistNo', tmp);
            this.$set(this.basicForm, 'orgCode', tmp.slice(startIndex, endIndex));
        },
        getAdvanceValue(data) {
            this.$set(this.bankForm, 'bankName', data.bankName);
            this.$set(this.bankForm, 'bankCode', data.bankCode);
            this.$set(this.bankForm, 'ubankNo', data.ubankNo);
            this.$set(this.bankForm, 'bankAddress', data.bankAddress);
        },
        getOtherAdvanceValue(data) {
            if (data.hasOwnProperty('companyCode')) {
                this.$set(this.otherForm, 'companyCode', data.companyCode);
                this.$set(this.otherForm, 'companyName', data.companyName);
                this.setAdvanceUrl(data.companyCode);
            } else if (data.hasOwnProperty('siteCode')) {
                this.$set(this.otherForm, 'siteCode', data.siteCode);
                this.$set(this.otherForm, 'siteName', data.siteName);
            }
        },
        selectTransportType(data) {
            this.carrierOptions = [];
            this.carriersForm.transType = '';
            this.getCarriersTypeData(data);
            this.getAttachmentForChange('trans')
        },
        getCarriersTypeData(data) {
            const params = {
                propertyNature: this.supplierTab.propertyNature,
                supplierType: this.supplierTab.supplierType,
                isOverseas: this.supplierTab.isOverseas,
                businessType: this.supplierTab.businessType,
                transType: '',
                leasingType: '',
                transportType: data,
                corporateType: this.supplierTab.corporateType
            };
            const func = data ? getCarriersType : getBusinessType;
            func(params).then(res => {
                if (res && res.code === '0') {
                    if (res.data.length === 0 && this.carriersForm.transType === '') {
                        this.showCarriersTab = false;
                        return false;
                    }
                    this.showCarriersTab = true;
                    const carrierOptions = [];
                    for (let i = 0; i < res.data.length; i++) {
                        if (this.dict.SRM_SHIPPER_TYPE[res.data[i]]) {
                            carrierOptions.push({
                                value: res.data[i],
                                label: this.dict.SRM_SHIPPER_TYPE[res.data[i]]
                            });
                        }
                    }
                    this.carrierOptions = carrierOptions;
                }
            });
        },
        isDone(row){
            return (row.tabConfigCode&&row.params) || !!(row.downUrl || row.fileUrl) || row.hasData === '1'
        },
        confirmDialog(ruleForm) {
            this.handleClick();
            this.$refs[ this.ruleForm ].validate((valid) => {
                if (!valid) {
                    return false;
                }

                if(['corporateForm'].includes(this.ruleForm)){
                    //选中合作方式tab时才校验
                    let tips = this.attachmentList.reduce((t,v) => {
                        if(!v.downUrl){
                            t.push(v.qualificationName)
                        }
                        return t
                    },[])
                    if(tips.length){
                        this.$message.warning(`请上传${tips.join('、')}信息`)
                        return false
                    }
                }
                if(['carriersForm'].includes(this.ruleForm)){
                    //选中承运商tab时才校验
                    if(this.attachmentList.some(v => !this.isDone(v))){
                        this.$message.warning(`请先完成所有补充信息的上传或填写后，再提交变更审批。`)
                        return false
                    }
                }
                const that = this;
                const { changeTypeKey, label } = FORM_CONFIG[that.ruleForm];
                // 这里不能使用 { ...that[changeTypeKey] } 浅拷贝
                // 因为后续修改basicForm.list时，需要submitData.list也跟着一致变化；否则会失去关联，submitData.list不会变化，一个坑
                const submitData = that[changeTypeKey];
                submitData.list = this.attachmentList.filter(v => !v.tabConfigCode && v.qualificationName !== '业务运作规模清单').map(v => {
                    let downUrl = '', fileName = '', fileId = ''
                    if(v.fileUrl){
                        //fileUrl有值，就是非身份证
                        downUrl = v.fileUrl
                        fileName = v.fileName
                        fileId = v.fileId
                    }else{
                        if(v.qualificationName.indexOf('人像') > -1){
                            downUrl = v.uploadIdentityFrontUrl
                            fileName = v.uploadIdentityFront
                            fileId = v.uploadIdentityFrontFileId
                        }
                        if(v.qualificationName.indexOf('国徽') > -1){
                            downUrl = v.uploadIdentityBehindUrl
                            fileName = v.uploadIdentityBehind
                            fileId = v.uploadIdentityBehindFileId
                        }
                    }
                    
                    return {
                        fileId,
                        fileName,
                        downUrl,
                        qualificationName: v.qualificationName,
                        certificateNo: v.certificateNo,
                        certificateBeginDate: v.certificateBeginDate,
                        certificateEndDate: v.certificateEndDate
                    }
                })
                if (that.ruleForm === 'basicForm') {
                    that.basicForm.list = [];
                    if (this.promptMsg()) {
                        if (that.basicForm.corporateName) {
                            that.basicForm.supplierNameCn = that.basicForm.supplierNameCn.trim().toUpperCase();
                        }
                        if (that.basicForm.corporateName) {
                            that.basicForm.corporateName = that.basicForm.corporateName.trim().toUpperCase();
                        }
                        if (that.basicForm.idCard) {
                            that.basicForm.idCard = that.basicForm.idCard.toUpperCase();
                        }
                        submitData.isChina = that.isChina;
                    }
                }
                this.attachmentList.filter(v => v.tabConfigCode).forEach(v => {
                    if(v.tabConfigCode === 13){
                        //常跑线路tab
                        submitData.commonRouteInfo = v.commonRouteInfo
                    }
                    if(v.tabConfigCode === 18){
                        //零担对接平台tab
                        submitData.lessSystemInfo = v.lessSystemInfo
                    }
                })
                that.$emit('submitCallback', { changeType: changeTypeKey, subject: `供应商变更-${label}-审批-${this.supplierCode}`, data: submitData });
            });
        },
        promptMsg() {
            let excludeItems = [];
            let flag = true;
            if (this.supplierTab.supplierType === OTHER_SUPPLIER) {
                excludeItems = ['身份证人像面', '身份证国徽面'];
            } else if (this.supplierTab.supplierType === OCEANFREIGHT_SUPPLIER) {
                excludeItems = ['身份证人像面', '身份证国徽面', '营业执照'];
            }
            const that = this;
            for (let i = 0; i < that.tableData.length; i++) {
                // 旧数据修复 身份证正/反面改成身份证人像/国徽面
                if (that.tableData[i].qualificationName === '身份证正面') {
                    that.tableData[i].qualificationName = '身份证人像面';
                }
                if (that.tableData[i].qualificationName === '身份证反面') {
                    that.tableData[i].qualificationName = '身份证国徽面';
                }
                if (!that.tableData[i].downUrl) {
                    if (excludeItems.indexOf(that.tableData[i].qualificationName) < 0) {
                        that.$message.warning(`请上传${that.tableData[i].qualificationName}附件`);
                        that.basicForm.list = [];
                        flag = false;
                        break;
                    }
                } else {
                    const tmp = {
                        fileId: that.tableData[i].fileId,
                        fileName: that.tableData[i].fileName,
                        downUrl: that.tableData[i].downUrl,
                        qualificationName: that.tableData[i].qualificationName
                    };
                    that.basicForm.list.push(tmp);
                }
            }
            return flag;
        },
        changeCorporateName() {
            let behindStr = '';
            if (this.basicForm.supplierNameCn.includes('-')) {
                behindStr = this.basicForm.supplierNameCn.slice(this.basicForm.supplierNameCn.indexOf('-'));
                this.$set(this.basicForm, 'supplierNameCn', this.basicForm.corporateName + behindStr);
            } else {
                const hasNum = this.basicForm.supplierNameCn.match(/[0-9]+/);
                if (hasNum) {
                    behindStr = this.basicForm.supplierNameCn.slice(hasNum.index);
                    this.$set(this.basicForm, 'supplierNameCn', this.basicForm.corporateName + behindStr);
                } else {
                    this.$set(this.basicForm, 'supplierNameCn', this.basicForm.corporateName);
                }
            }
        },
        // 服务平台根据分公司筛选
        setAdvanceUrl(companyCode) {
            this.siteParams.advanceUrl = companyCode ? `searchPlatform?companyCode=${companyCode}` : 'searchPlatform';
        },
        // 将对象
        objectToArray(data) {
            return Object.entries(data).map(item => ({ label: item[1], value: item[0] }));
        },
        tbtPropsChange(val) {
            this.basicForm.transportBusinessTypeList = val
        },
    },
    mounted() {
        this.supplierCode = this.$route.query.supplierCode;
        dictWithUrl('SRM_SHIPPER_TYPE,SRM_TRANSPORT_TYPE,BID_INVOICE_TYPE,SU_INVOICE_TAX_RATE,BID_PAYMENT_TERMS').then(res => {
            this.invoiceTypeOptions = this.objectToArray(res.data.BID_INVOICE_TYPE);
            this.taxRateOptions = this.objectToArray(res.data.SU_INVOICE_TAX_RATE);
            this.dict = res.data;

            //付款条件字典要按规定顺序进行排序
            // 按这个字典编码进行排序 ['1','50','27','28','33','29','30','31','34','32']
            const sortArr = ['1','50','27','28','33','29','30','31','34','32']
            //查找出不在编码排序内的选项
            const newOpts = Object.keys(res.data['BID_PAYMENT_TERMS']).filter(v => sortArr.indexOf(v) === -1)
            //将固定顺序的选项（已启用）与不在顺序内的选项合并，后者选项排后面
            const paymentOpts = [...(sortArr.filter(v => res.data['BID_PAYMENT_TERMS'][v])),...newOpts]

            this.paymentOptArr = paymentOpts.map(v => {
                return {
                    label: res.data['BID_PAYMENT_TERMS'][v],
                    value: v
                }
            })
        });
    },
    watch: {
        openChangeDialog(v){
            if(!v){
                this.attachmentList = []
            }else{
                if(this.disabled){
                    if(this.changeType === '6'){
                        this.attachmentList = this.corporateForm.list || []
                    }else if(this.changeType === '3'){
                        this.attachmentList = this.carriersForm.list || []
                    }
                }else{
                   this.getAttachmentForChange((this.changeType == 3 || this.showCarriersType) ? 'trans' : 'corp')
                }
            }
        },
        activeName: {
            handler(newVal) {
                this.activeName_ = newVal;
            },
            immediate: true
        },
        carriersForm: {
            handler(nVal) {
                this.getCarriersTypeData(nVal.transportType || null);
            }
        },
        otherForm: {
            handler(nVal) {
                this.setAdvanceUrl(nVal.companyCode);
            }
        },
        supplierTab: {
            handler(nVal) {
                if (nVal.propertyNature === COMPANY) {
                    this.basicRules.societyCreditCode = [
                        { required: true, message: '请输入公司统一社会信用代码', trigger: ['blur', 'change'] },
                        { pattern: /^[0-9a-zA-Z]{18}$/, message: '请输入18位数字或字母', trigger: ['blur', 'change'] }
                    ];
                } else {
                    this.basicRules.societyCreditCode = [];
                }
                if (nVal.supplierType === LOGISTICS_SUPPLIER) {
                    this.basicRules.idCard.push({ required: true, message: '请输入身份证号', trigger: ['blur', 'change'] });
                }
            }
        }
    }
};
</script>
<style lang="less">
.change_information_dialog {
    .table {
        margin-top: 10px;
    }

    .table-title {
        font-size: 16px;
    }

    .upload_file {
        position: relative;

        .upload_file_icon {
            position: absolute;
            top: 2px;
            left: 99%;
            height: 28px;
            font-size: 16px;
            color: #33c9cc;
        }
    }

    .upload {
        float: left;
        width: 50px;
    }

    .advance-item {
        .el-input__inner {
            width: 120px;
        }
    }

    .select-item {
        width: 160px;
    }

    .el-input__inner, .el-form-item__content {
        width: 160px;
    }

    .fileData {
        .el-input__inner, .el-input {
            float: left;
            width: 140px;
        }

        .bankUpload {
            float: left;
            margin-left: 5px;
        }
    }

    .el-input.is-disabled .el-input__inner {
        color: #404040;
        background-color: #ebebe4;
        border: 1px solid #999;
    }

    .isChina__radio {
        position: absolute; top: 0; right: -155px;

        .el-radio {
            margin-right: 15px;
        }
    }

    .el-date-editor.el-input {
        width: 100%;
    }
    .two-columns{
        display: flex;
        .otp-select {
            flex: 1;
            width: 100%;
            min-width: 60px;
        }
        .el-input {
            width: 100%;
            input{
                width: 100%;
            }
            // min-width: 60px;
        }
        .two-columns-input{
            flex: 7;
            margin-left: 5px; 
        }
    }
}

.quality-dialog{
    .input-class {
        width: 280px;
    }

    .el-input{
        width: 280px !important;
    }

    .upload-item {
        position: relative;

        .upload-item-icon {
            position: absolute;
            top: 2px;
            width: 265px;
            height: 28px;
            font-size: 16px;
            color: #33c9cc;
        }

        .upload-demo {
            width: 100%;
            height: 28px;
        }
    }

    .el-upload {
        width: 100%;
        height: 28px;
        text-align: right;
    }

    .upload_icon {
        width: 100%;
        height: 23px;
        box-sizing: border-box;
    }

    .preview_btn {
        margin-left: 10px;
        text-decoration: underline;
        color: #33c9cc;
        cursor: pointer;
    }
}
</style>